import { Power4, gsap } from "gsap";

export const headerAnimation = () => {
    const tl = gsap.timeline({
        defaults: {
            ease: Power4.easeInOut,
            duration: 0.75,
        },
    });

    tl.fromTo(
        ".ais-SearchBox-input",
        {
            opacity: 0,
        },
        {
            opacity: 1,
        },
        "0.25",
    ).fromTo(
        ".search-header__close-button",

        {
            opacity: 0,
        },
        {
            opacity: 1,
        },
        "<",
    );
    return tl;
};
